<template>
  <footer>
      <router-link to="/mentions-legales">Mentions légales</router-link>
      <router-link to="/vos-donnees-et-vos-droits">Vos données et vos droits</router-link>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss">
footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 42px;
  background-color: $primary-color;
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    margin: 0;
    color: #fff;
  }
  a + a {
    margin-left: $h-spacer-lg;
  }
}
</style>
